import { render } from "./BusinessIcon.vue?vue&type=template&id=b596c764"
import script from "./BusinessIcon.vue?vue&type=script&lang=js"
export * from "./BusinessIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__